
import Game from "./game";
import Run from "./run";
import Space from "./frp/space";
import Stream from "./frp/stream";
import SETTINGS from 'settings'

export default function({
    server,
    construct,
    rootContainer,
    errorView,
    uiConfig,
    parent,
    uiRootContainer,
    $tickerSeconds,
    server$,
    errorDriver,
    params,
})
{
    
    const $keyboard = new Stream( "keyboard" );
    window.addEventListener('keydown', event => $keyboard.next( event.which ) );
    
    window.onkeydown = e => {
        if (e.keyCode === 27 || e.keyCode === 32 || e.keyCode >= 112 && e.keyCode <= 121 ) { // F1-F10
            return false;
        }
        
        return true;
    };
    
    window.onkeyup = e => {
        if (e.keyCode === 27 || e.keyCode === 32 || e.keyCode >= 112 && e.keyCode <= 121 ) { // F1-F10
            return false;
        }
        
        return true;
    };
    
    const app = {};
    
    let needReset = true;
    server.$error.on( () => needReset = true )
    server.$net.on( () =>
    {
        if ( ! needReset ) return
        
        needReset = false;
        
        dispose( app );
        
        console.log( "INIT" );
        
        app.space = new Space( "root" );
        
        app.gameContainer = new PIXI.Container;
        rootContainer.addChild( app.gameContainer );
        rootContainer.addChild( errorView );
        app.always_interactive_container = new PIXI.Container
        rootContainer.addChild( app.always_interactive_container )
        
        if ( construct ) app.constructed = construct( server.loginData.spec, app.space )
        else app.constructed = {}
        if ( params.reactive ) app.constructed.reactive = params.reactive

        if (uiRootContainer) {
            app.uiContainer = new PIXI.Container;
            uiRootContainer.addChild(app.uiContainer)
        }
        
        const run = Run(
            app.gameContainer,
            app.constructed,
            {
                uiConfig,
                spec : server.loginData.spec,
            },
            app.space,
            app.uiContainer,
            app.always_interactive_container
        );
        
        Game(
            app.space,
            run,
            {
                lines : server.loginData.spec.lines_array,
                multipliers : server.loginData.spec.bets_array,
            },
            server.bonusSettings,
            server.loginData.spec
        );
        
        if ( app.constructed.reactive )
        {
            console.log( "Merging library structure with current game ..." );
            app.destroy = app.constructed.reactive( app.space, app.constructed );
            console.log( "... merged." );
        }
        
        console.time( "Apply" );
        
        app.space.apply();
        
        //glue only after the whole game model built to let different parts subscribe BEFORE state comes in:
        app.space.s( "goLobby" ).map(() => false).to(parent.s( 'need_fullscreen' ));
        app.space.s( "goLobby" ).map(() => false).to(parent.s('need_resize'));
        app.space.s( "goLobby" ).to(parent.s('goToLobby'))
        app.space.s( "goLobby" ).to( errorDriver.$goLobby );
        app.space.s( "progress_indicator" ).to( errorDriver.$preloader )
        errorDriver.$preloader.to( app.space.s( "progress_indicator_get" ) )
        app.space.s( 'preloader_also_visible').to( errorDriver.$preloader_also_visible )
        app.space.s( "request" ).to( server$.$request );
        server$.$pending.to( app.space.s( "pending" ) );
        server$.$lastRequest.to( app.space.s( "lastRequest" ) );
        server.$error.to( app.space.s( "error" ) );
        glue( server$.$net, app.space.s( "net" ) )
        glue( server.$balancePoll, app.space.s( "balance_poll" ) )
        glue( server.$progressive_jackpot, app.space.s( "progressive_jackpot" ) )
        
        $tickerSeconds.to( app.space.s( "ticker" ) );
        $keyboard.to( app.space.s( 'raw_keyboard' ) )
        
        glue( parent.s('change_screen'), app.space.s( 'change_screen' ) )
        glue( parent.s( 'resize' ), app.space.s( 'size' ) )
        
        app.space.s( 'ui:need_fullscreen' ).next( parent.s( 'need_fullscreen' ).value )
        app.space.s( 'ui:need_fullscreen' ).to( parent.s( 'need_fullscreen' ) )
        app.space.s( 'ui:landscape' ).next( parent.s( 'landscape' ).value )
        app.space.s( 'ui:landscape' ).to( parent.s( 'landscape' ) )

        //попросили по умолчанию включать звук 
        //app.space.s( 'muteSound' ).next( parent.s( 'load:postpone_sounds' ).value )
        app.space.s( 'muteSound' ).to( parent.s( 'load:postpone_sounds' ) )
        app.space.s( 'muteSound' ).next( false )

        parent.s( 'load:complete' ).to( app.space.s( 'load:complete' ) )
        app.space.s( 'load:load' ).to( parent.s( 'load:load' ) )
        glue( parent.s( 'load:loading' ), app.space.s( 'load:loading' ) )

        app.space.s( 'screen_ratio' ).to( parent.s( 'screen_ratio' ) )
        app.space.s( 'screen_ratio' ).next( parent.s( 'screen_ratio' ).value )

        parent.s('show_tap_screen').filter(show => show).map(() => false).to(app.space.s('ui:isAutoplay'))

        glue( parent.s( 'tab_visibility' ), app.space.s( 'tab_visibility' ) )

        app.space.s( 'interactive' ).on( i => {
            app.gameContainer.interactive = i
            app.gameContainer.interactiveChildren = i
        } )
        
        console.timeEnd( "Apply" );
        
        
        if ( ! SETTINGS.isMobile ) {
            console.log( 'Docs:' )
            app.space.print();
        }
    } );
    if ( server.$net.value ) server.$net.next( server.$net.value )
}

function glue( source, target )
{
    source.to( target )
    target.next( source.value )
}

function dispose( app )
{

    // при перезапуске вернем все звуки назад
    sounds.muteAll(false);

    if ( app.gameContainer )
    {
        for ( const child of app.gameContainer.children )
        {
            if ( child.terminate ) child.terminate();
        }
        app.gameContainer.destroy( { children : true } );
    }

    if (app.uiContainer) {
        app.uiContainer.destroy( { children : true } );
    }

    if ( app.always_interactive_container ) app.always_interactive_container.destroy( { children : true } )
    
    if ( app.space )
    {
        app.space.clear();
    }
    
    if ( typeof app.destroy === 'function' ) app.destroy()
    
    TWEEN.removeAll();
}





// WEBPACK FOOTER //
// ./src/library/init.es6